import React from 'react';
import withIcon from '../utilities/withIcon';

const IconInbox = () => {
  return (
    <g>
      <path d="m15.8957 7.3561a.7411.7411 0 0 0 -.0678-.2561.706.706 0 0 0 -.0413-.1035l-3.2295-4.9413a.751.751 0 0 0 -.6279-.34h-8.1064a.7494.7494 0 0 0 -.6426.3638l-2.9802 4.9576c-.0089.0148-.009.0317-.0167.0468a.7269.7269 0 0 0 -.0544.1525.73.73 0 0 0 -.0264.1307c-.002.0204-.0125.0379-.0125.0587v4.6856a2.2378 2.2378 0 0 0 2.292 2.1738h11.2357a2.2378 2.2378 0 0 0 2.292-2.1738v-4.6856a.6916.6916 0 0 0 -.014-.0692zm-11.6491-4.1408h7.2764l2.2618 3.46h-2.88a.7567.7567 0 0 0 -.7129.5171 2.5184 2.5184 0 0 1 -2.3232 1.6919 2.2048 2.2048 0 0 1 -2.333-1.6113.75.75 0 0 0 -.7344-.5976h-2.6348zm10.1634 8.8955a.75.75 0 0 1 -.792.6738h-11.2357a.75.75 0 0 1 -.792-.6738v-3.9355h2.6739a3.7578 3.7578 0 0 0 3.6045 2.209 3.9485 3.9485 0 0 0 3.53-2.209h3.0113z" />
    </g>
  );
};

export default withIcon(IconInbox);
